import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-role-panel"
}
const _hoisted_2 = { class: "role-info" }
const _hoisted_3 = {
  key: 0,
  class: "teammates-info"
}
const _hoisted_4 = { class: "teammates-list" }

import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyRolePanel',
  setup(__props) {

const gameStore = useGameStore();

const roleMap: Record<string, string> = {
    mafia: "Мафия",
    citizen: "Мирный житель",
    doctor: "Доктор",
    comissar: "Комиссар",
    whore: "Потаскуха"
};

const formattedRole = computed(() => {
    const role = gameStore.myRole;
    return role ? roleMap[role] || role : '';
});

const teamMembers = computed(() => {
    if (!gameStore.myPlayer) return [];
    const members = [{ name: `${gameStore.myPlayer.name} (Вы)`, isMe: true }];
    gameStore.teammates.forEach(name => members.push({ name, isMe: false }));
    return members;
});

return (_ctx: any,_cache: any) => {
  return (_unref(gameStore).myRole)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Ваша роль:", -1)),
          _createElementVNode("strong", null, _toDisplayString(formattedRole.value), 1)
        ]),
        (teamMembers.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "teammates-title" }, "Команда:", -1)),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamMembers.value, (member) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: member.name,
                    class: _normalizeClass({ 'is-me': member.isMe })
                  }, _toDisplayString(member.name), 3))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})